// Resolve product image URLs. Backend may return relative paths like /api/files/...
// which need the backend host prepended, while existing products may store full URLs.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

export function resolveImageUrl(url) {
  if (!url) return "";
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  if (url.startsWith("/")) return `${BACKEND_URL}${url}`;
  return url;
}
